import * as React from 'react';
import classNames from 'classnames';
import styles from './SantaBundleBackground.scss';
import { isMobileOrTabletWindow } from '~/utils/utils';
import VideoBackground from '~/components/VideoBackground/VideoBackground';
import { SANTA_SIZE, VIDEO_BUNDLE_PREVIEW } from '~/Layouts/Themes/SantaPage/settings';
import { useAvailableSound } from '~/hooks/useAvailableSound';
import { State } from '~/Reducers';
import { useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { UserGraphicsQualityPreset, UserGraphicsQualityPresetTypes } from '@wg/web2clientapi/browser/getUserGraphicsQualityPreset';
import { ICurrentPage } from '~/Actions/ActionAppType';

interface ISantaBundleBackground {
    bundle: IBundle;
}

interface IStateSelector {
    isTrusted: boolean;
    userGraphics: UserGraphicsQualityPreset;
    categories: ICategories;
    currentPage: ICurrentPage;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        isTrusted: state.ReducerApp.isTrusted,
        userGraphics: state.ReducerAccount.userGraphics,
        categories: state.ReducerApp.categories,
        currentPage: state.ReducerApp.currentPage,
    };
};

const SantaBundleBackground = ({ bundle }: ISantaBundleBackground) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const isAvailableSoundEffect = useAvailableSound(state.categories[state.currentPage?.name], bundle);

    if (isMobileOrTabletWindow) {
        return null;
    }

    const SIZE = SANTA_SIZE[bundle.groupName];

    if (!VIDEO_BUNDLE_PREVIEW[SIZE]?.static) {
        return null;
    }

    let muted = !isAvailableSoundEffect;
    if (!state.isTrusted) {
        muted = true;
    }

    const isLowGraphics = state.userGraphics?.preset === UserGraphicsQualityPresetTypes.LOW;

    return (
        <div className={styles.wrapper}>
            <VideoBackground
                key={bundle.id}
                poster={bundle.icons.innerBackground}
                video={isLowGraphics ? null : VIDEO_BUNDLE_PREVIEW[SIZE].static}
                className={styles.videoBackgroundWrapper}
                posterClassName={classNames(styles.background)}
                videoClassName={styles.videoBackground}
                muted={muted}
                volume={0.5}
            ></VideoBackground>
        </div>
    );
};

export default SantaBundleBackground;
